import React from "react";

const VisualizationLoader = () => (
  <div className="preview-visualization__loading-container">
    <div className="preview-visualization__loader-image" />
    <img
      className="preview-visualization__placeholder-image"
      src={`${window.tcbase.urls.static}/images/preview-sample-placeholder.png`}
      alt="Preview / Visualization"
    />
  </div>
);

export default VisualizationLoader;
